var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import localForage from "localforage";
import isAfter from "date-fns/isAfter";
import addDays from "date-fns/addDays";
import addSeconds from "date-fns/addSeconds";
export function getCachedValue(key) {
    return __awaiter(this, void 0, void 0, function* () {
        // try {
        const dateString = yield localForage.getItem(`fitplan-${key}-expiration`);
        const expirationDate = new Date(dateString);
        if (isAfter(new Date(), expirationDate)) {
            yield localForage.removeItem(`fitplan-${key}`);
            yield localForage.removeItem(`fitplan-${key}-expiration`);
            return;
        }
        const res = yield localForage.getItem(`fitplan-${key}`);
        console.log(`getting fitplan-${key} as`, res);
        return res;
        // } catch (err) {}
        return;
    });
}
export function setCachedValue(key, value, daysTillExpiry = 1) {
    return __awaiter(this, void 0, void 0, function* () {
        // try {
        console.log(`setting fitplan-${key} to`, value);
        yield localForage.setItem(`fitplan-${key}`, value);
        yield localForage.setItem(`fitplan-${key}-expiration`, daysTillExpiry === 0
            ? addSeconds(new Date(), 30).toISOString()
            : addDays(new Date(), daysTillExpiry).toISOString());
        // } catch (err) {}
        return;
    });
}
export function deleteCachedValue(key) {
    return __awaiter(this, void 0, void 0, function* () {
        // try {
        console.log(`deleteing fitplan-${key}`);
        yield localForage.removeItem(`fitplan-${key}`);
        yield localForage.removeItem(`fitplan-${key}-expiration`);
        // } catch (err) {}
        return;
    });
}
export function saveWorkoutResult(workout, startTime, endTime) {
    return __awaiter(this, void 0, void 0, function* () {
        const saved = (yield getCachedValue("saved-workouts")) || [];
        saved.push({
            workout,
            startTime: startTime.toISOString(),
            endTime: endTime.toISOString(),
        });
        yield setCachedValue("saved-workouts", saved, 365);
    });
}
export function getSavedWorkoutResults() {
    return __awaiter(this, void 0, void 0, function* () {
        return (yield getCachedValue("saved-workouts")) || [];
    });
}
export function clearCache() {
    return __awaiter(this, void 0, void 0, function* () {
        yield localForage.clear();
    });
}
//# sourceMappingURL=data:application/json;base64,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